var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "#8B8B8B",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9326 3.90217L13.1252 17.7903C13.0799 17.9211 12.9945 18.0342 12.8811 18.1135C12.7676 18.1928 12.632 18.2342 12.4937 18.2318C12.3553 18.2294 12.2212 18.1833 12.1106 18.1001C12 18.017 11.9185 17.9009 11.8778 17.7687L9.94553 11.4887C9.91405 11.3864 9.85803 11.2933 9.78234 11.2177C9.70665 11.142 9.6136 11.0859 9.5113 11.0545L3.23134 9.12217C3.09906 9.08148 2.98304 9 2.89986 8.88939C2.81667 8.77879 2.77058 8.64472 2.76818 8.50635C2.76578 8.36797 2.80718 8.23238 2.88647 8.11895C2.96576 8.00553 3.07888 7.92007 3.20966 7.8748L17.0978 3.06735C17.2142 3.02707 17.3396 3.02034 17.4596 3.04795C17.5796 3.07556 17.6895 3.13638 17.7765 3.22346C17.8636 3.31055 17.9244 3.42038 17.9521 3.5404C17.9797 3.66042 17.9729 3.78579 17.9326 3.90217V3.90217Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationArrowRight);
export default __webpack_public_path__ + "static/media/navigationArrowRight.bd2ae0099f5438e4f81d1a6679d294ba.svg";
export { ForwardRef as ReactComponent };